module.exports = __webpack_public_path__ + "img/user-octagon.f3bd12d9.svg";